import React from "react";
import { Flex, Text, Button } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { PageHeader } from "../../page-header/pageHeader";

import { useAudioTestEndedWorkingStyles } from "./AudioTestEndedWorking.styles";
import { AudioTestEndedWorkingProps } from "./AudioTestEndedWorking.types";

export const AudioTestEndedWorking: React.FC<AudioTestEndedWorkingProps> = ({
  completeTest,
  runTestAgain,
}) => {
  const audioTestEndedWorkingStyles = useAudioTestEndedWorkingStyles();
  const { t } = useTranslation();

  return (
    <Flex
      vAlign="stretch"
      hAlign="center"
      gap="gap.large"
      column
      styles={audioTestEndedWorkingStyles.container}
    >
      <Flex vAlign="center">
        <PageHeader
          headerStyles={audioTestEndedWorkingStyles.finishPromptHeader}
          headerContent={t("AUDIO_TEST_ENDED_SUCCESS_HEADER")}
          descriptionStyles={audioTestEndedWorkingStyles.description}
          descriptionContent={t("AUDIO_TEST_ENDED_SUCCESS_DESCRIPTION")}
        />
      </Flex>
      <Flex.Item push>
        <Flex
          column
          hAlign="center"
          vAlign="end"
          gap="gap.medium"
          styles={audioTestEndedWorkingStyles.buttonGroupFinish}
        >
          <Button
            className="focus-button"
            tabIndex={0}
            onClick={completeTest}
            fluid
            styles={audioTestEndedWorkingStyles.finish}
            content={
              <Text
                size="large"
                weight="semibold"
                align="center"
                content={<>{t("FINISH_TEST")}</>}
              />
            }
            data-testid="completeTestWorkingButton"
          />

          <Button
            className="focus-button"
            tabIndex={1}
            onClick={runTestAgain}
            fluid
            styles={audioTestEndedWorkingStyles.runTestAgain}
            content={
              <Text
                size="large"
                weight="semibold"
                align="center"
                content={<>{t("BACK_TO_TEST")}</>}
              />
            }
            data-testid="runTestAgain"
          />
        </Flex>
      </Flex.Item>
    </Flex>
  );
};
